import { VueConstructor } from 'vue';
import { Vue } from 'vue-property-decorator';

import SBButton from './SBButton.vue';
import SBTextbox from './SBTextbox.vue';
import SBTitle from './SBTitle.vue';
import SBSection from './SBSection.vue';
import SBNextBack from './SBNextBack.vue';
import SBScrollContent from './SBScrollContent.vue';
import SBImageStep from './SBImageStep.vue';
import SBImageContent from './SBImageContent.vue';
import SBArtistListTitle from './SBArtistListTitle.vue';
import SBArtistListCategoryIcon from './SBArtistListCategoryIcon.vue';
import SBRadio from './SBRadio.vue';
import SBRadioGroup from './SBRadioGroup.vue';
import SBCheckbox from './SBCheckbox.vue';
import SBPopup from './SBPopup.vue';
import SBBreadcrumb from './SBBreadcrumb.vue';
import SBImageTitle from './SBImageTitle.vue';
import SBButtonSmall from './SBButtonSmall.vue';
import SBButtonSmallGray from './SBButtonSmallGray.vue';
import SBButtonClosed from './SBButtonClosed.vue';
import SBButtonGeneral from './SBButtonGeneral.vue';
import SBCategoryButton from './SBCategoryButton.vue';
import SBSubTitle from './SBSubTitle.vue';
import SBHeadingTitle from './SBHeadingTitle.vue';
import SBPagetop from './SBPagetop.vue';
import SBSNSIcon from './SBSNSIcon.vue';
import SBHorizontalScroll from './SBHorizontalScroll.vue';
import SBHorizontalScrollItem from './SBHorizontalScrollItem.vue';
import SBKurukuru from "./SBKurukuru.vue";
import SBLoading from "./SBLoading.vue";
import SBUserPlan from "./SBUserPlan.vue";
import SBFaqTitle from "./SBFaqTitle.vue";
import SBMailAuthentication from "./SBMailAuthentication.vue";
import SBUserData from "./SBUserData.vue";
import SBText from "./SBText.vue";
import SBOrderHistory from "./SBOrderHistory.vue";
import SBPaymentMethodSelect from "./SBPaymentMethodSelect.vue";
import SBImg from "./SBImg"
import Slick from "vue-slick"
import NewUser from "../views/mypage/inner/NewUser.vue"
import PassRemind from "../views/mypage/inner/PassRemind.vue"
import SBCategory from "./SBCategory.vue"
import SBSignUpForm from "./SBSignUpForm.vue"

let DefaultComponents: { [name: string]: VueConstructor<Vue> } = {
    SBButton,
    SBTextbox,
    SBTitle,
    SBSection,
    SBNextBack,
    SBScrollContent,
    SBHorizontalScroll,
    SBHorizontalScrollItem,
    SBArtistListTitle,
    SBArtistListCategoryIcon,
    SBImageStep,
    SBImageContent,
    SBRadio,
    SBRadioGroup,
    SBCheckbox,
    SBPopup,
    SBBreadcrumb,
    SBImageTitle,
    SBButtonSmall,
    SBButtonSmallGray,
    SBButtonClosed,
    SBButtonGeneral,
    SBCategoryButton,
    SBSubTitle,
    SBHeadingTitle,
    SBPagetop,
    SBSNSIcon,
    SBKurukuru,
    SBLoading,
    SBUserPlan,
    SBFaqTitle,
    SBMailAuthentication,
    SBUserData,
    SBText,
    SBOrderHistory,
    SBPaymentMethodSelect,
    SBImg,
    Slick,
    NewUser,
    PassRemind,
    SBCategory,
    SBSignUpForm,
};

export function AllComponents(): { [name: string]: VueConstructor<Vue> } {
    return DefaultComponents;
};
